<template>
    <v-dialog v-model="dialog" max-width="500px">
      <v-overlay :value="loading" absolute opacity="0.7">
        <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>
      </v-overlay>
      <v-card>
        <v-card-title>新增课件</v-card-title>
        <v-card-subtitle>
            {{ formData.memberName }}
        </v-card-subtitle>
        <v-card-text>
            
          <v-form ref="form" v-model="valid">
            <v-file-input
              v-model="formData.coursewareFile"
              label="上传课件"
              :rules="[
                v => !!v || '请选择文件',
                v => !v || /\.(pdf|docx?|xlsx?)$/i.test(v.name) || '只允许上传 .pdf, .doc, .docx, .xls, .xlsx 格式的文件'
                ]"
              required
              accept=".pdf,.doc,.docx,.xls,.xlsx"
              show-size
            ></v-file-input>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="close">取消</v-btn>
          <v-btn color="blue darken-1" text @click="submit">确定</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </template>
  
  <script>
  import { coursewareApi } from '@/api/courseware'
  
  export default {
    name: 'CreateCoursewarePopup',
    data() {
      return {
        loading: false,
        dialog: false,
        valid: false,
        formData: {
          memberId: null,
          memberName: null,
          coursewareFile: null
        },
      }
    },
    methods: {
      open(memberId, memberName) {
        this.formData.memberId = memberId;
        this.formData.memberName = memberName;
        this.dialog = true;
      },
      close() {
        this.formData = {
          memberId: null,
          memberName: null,
          coursewareFile: null
        };
        this.dialog = false;
        this.$refs.form.reset();
      },
      async submit() {
        if (!this.$refs.form.validate()) return;
  
        try {
          this.loading = true;
          const params = {
            memberId: this.formData.memberId,
            coursewareFile: this.formData.coursewareFile
          };
          
          console.log('Submitting with params:', params);
          
          const response = await coursewareApi.createCourseware(params);
          console.log(response);
          this.$emit('courseware-created');
          this.close();
          this.$toast.success('课件创建成功');
        } catch (error) {
          const errorMessage = error.response?.data?.message || error.message || '未知错误';
          this.$toast.error('创建失败：' + errorMessage);
        } finally {
          this.loading = false;
        }
      }
    }
  }
  </script> 